import React, { Component } from "react";
import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import Select from 'react-select';
import { css } from "@emotion/core";
import { List } from 'react-virtualized';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import "./css/ftcr.css";
import * as moment from "moment";
import { connect } from "react-redux";
import { Collapse, Label, Button, Input, Form, FormGroup, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import ModalD from "react-awesome-modal";
import {BeatLoader} from 'react-spinners';
import loadingGif from "../assets/img/loading.gif";
const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align: center;
`;

var todayDate = new Date();
var timestamp = new Date().getTime();
var minDate = new Date('2020-10-01');
var yesterday = new Date(Date.now() - 24 * 60 * 60 * 1000);
var tod = moment(todayDate).format('MM/DD/YYYY');
var yest = moment(todayDate).format('MM/DD/YYYY');
var todShow = moment(todayDate).format('D MMM YYYY');
var yestShow = moment(todayDate).format('D MMM YYYY');
var todSend = moment(todayDate).format('YYYY-MM-DD');
var yestSend = moment(todayDate).format('YYYY-MM-DD');
var date_limit = moment(todayDate).format('MM/DD/YYYY');
var start_date_limit = moment(minDate).format('MM/DD/YYYY');
Array.prototype.move = function (from, to) {
    this.splice(to, 0, this.splice(from, 1)[0]);
    return this;
};
function enabledBody() {
    $('body').removeClass("back-disabled");
}

function disabledBody() {
    $('body').addClass("back-disabled");
}
function numDifferentiation(val) {
    if(val >= 10000000) val = (val/10000000).toFixed(2) + ' Cr';
    else if(val >= 100000) val = (val/100000).toFixed(2) + ' Lakh';
    else if(val >= 1000) val = (val/1000).toFixed(2) + ' K';
    return val;
}
class FundDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dateTo: tod,
            dateLimit: date_limit,
            dateToShow: todShow,
            todSend: todSend,
            yestSend: yestSend,
            datefrom: yest,
            datefromShow: yestShow,
            utid:"",
            is_valid_utid:false,
            show_details: "transaction today",
            ftcr_sidebar: true,
            rightBar:"col-md-9",
            search_loading:false,
            feature_data:[],
            merchant_name:"",
            chain_name:"",
            store_name:"",
            store_code:"",
            store_address:"",
            city_name:"",
            newModel: false,
            wallet_data:[],
            dateTow: tod,
            dateLimitw: date_limit,
            dateToShoww: todShow,
            todSendw: todSend,
            yestSendw: yestSend,
            datefromw: yest,
            datefromShoww: yestShow,
            wallet_loading:false,
            btid_loading:false,
            btid_data:[],
            isSettledLists: [{value: 'all', label: 'All'}, {value: 'SALE', label: 'SALE'}, {
                value: 'VOID',
                label: 'VOID'
            }, {
                value: 'REVERSAL',
                label: 'REVERSAL'
            },
                {
                    value: 'FAILED',
                    label: 'FAILED'
                },
                {
                    value: 'UPI Leg1',
                    label: 'UPI Leg1'
                }],
            isSettledIDs: '',
            isSettledValue: {value: '', label: 'All'},
            dateTos: tod,
            dateLimits: date_limit,
            dateToShows: todShow,
            todSends: todSend,
            yestSends: yestSend,
            datefroms: yest,
            datefromShows: yestShow,
            transaction_count: '-',
            sd_loading: false,
            sdetails_data:[],
            last_settlement_date:'',
            last_transaction_amount:'-',
            serviceTypeLists: [
                    {value: '', label: 'All'},
                    {value: 'Bank EMI',label: 'Bank EMI' },
                    {value: 'Brand EMI',label: 'Brand EMI' },
                    {value: 'Choice EMI',label: 'Choice EMI'},
                    {value: 'DC EMI',label: 'DC EMI'},
                    {value: 'Exclusive EMI',label: 'Exclusive EMI' },
                    {value: 'EFT',label: 'EFT' },
                    {value: 'FREE Emi Wallet',label: 'FREE Emi Wallet' },
                ],
        }
    }
    componentWillMount() {
        this.props.currentMenu("fundtransfer");
    }

    componentDidMount() {
        this.subMenuPermission();
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this.setState({
            user_id: decoded._id
        });
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");

        //console.log(decoded.object_type);
        this.setState({
            user_id: decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
        });
       
        
        if (decoded.object_type == 'Admin' || decoded.object_type == 'Innoviti') {
           
        }
        else if (decoded.object_type == 'Merchant') {
          
        }
        else if (decoded.object_type == 'Chain') {
           
        }
        else if (decoded.object_type == 'Store') {
            
        }
        else if (decoded.object_type == 'Acquirer Bank') {
           
        }

        else {
            this.unauthorize_access();
        }

    }
    subMenuPermission() {
        const token = localStorage.usertoken;
        let subMenuPermissions = [];
        let reportPermissions = [];
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        AllAccessPermissions.map((permissionName, i) => {
            if (permissionName.access_type == 'Submenu') {
                subMenuPermissions.push(permissionName.access_name);
            }
            if (permissionName.access_type == 'report') {
                reportPermissions.push(permissionName.access_name);
            }
        });
        if (subMenuPermissions.includes("transaction_reports") === false || reportPermissions.includes("phonePe_transaction") === false) {
            //this.unauthorize_access();
        }
    }
    unauthorize_access() {
        localStorage.removeItem("usertoken");
        localStorage.removeItem("userPermission");
        this.setState({
            loggedIn: false
        });
        alert("Unauthorized Access");
        window.location.href = "/";
    }
    _get_tr_listing(){
        var that = this;
        var postData = {
            status: this.state.isSettledIDs,
            utid: this.state.utid,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
        };
        if ($.fn.DataTable.isDataTable('#TrListsTable')) {
            $('#TrListsTable').DataTable().clear().destroy();
        }
        var TrListsTable = $('#TrListsTable').DataTable({
            order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 15,
                "bInfo" : false,
                "autoWidth": false,
                "responsive": true,
                "searching": true,
            "lengthMenu": [[15, 50, 100, 500 -1], [15, 50, 100, 500, "All"]],
            ajax: {
                url:config.get('API_URL')+ "/ftcr/get-transaction-listing",
                type: "POST",
                data: postData,
                dataSrc:function ( json ) { console.log(json);
                    enabledBody()
                    that.setState({
                        isChange: false
                    })
                    return json.data;
                },
                beforeSend: function(request) {
                    request.setRequestHeader("Authorization", localStorage.usertoken);
                },
                error: function (data) {
                    enabledBody()
                },
                complete: function (data) {
                    enabledBody()
                },
            },

            columns: [
                {"data":"prim_id"},
                {"data":"txn_type"},
                {"data":"echargeslip_url"},
                {"data":"Amount"},
                {"data":"Transaction Date"},
//                 {"data": "Transaction Time"},
                {"data":"transaction status"},
                {"data":"Card Holder Name"},
                {"data":"Issuer Bank"},
                {"data":"Card Number"},
                {"data":"Acquiring Bank"},
                {"data":"settlement status"},
                {"data":"Tenure"},
                {"data":"Rate of Interest"},
                {"data":"Error Reason"},
                {"data":"Category"},
                {"data":"brand"},
                {"data":"Model"},
                {"data":"Btid"},
                {"data":"co_reason_message"},
                {"data":"RRN No"},
                {"data":"parent_prim_id"},

            ],
            "columnDefs": [
                {
                        render: function (data, type, row) {
                            if(row['status']!='Failed' ) {
                                return '<td ><a href="#" data-code ="' + data + '" data-trdate ="' + row['Transaction Date'] + '" data-acqbank ="' + row['Acquiring Bank'] + '" data-primid ="' + row['prim_id'] + '">Get Receipt</a> &nbsp;</td>';
                            } else {
                                return '<td ></td>';
                            }

                        },
                        className: "charge_slip",
                        targets: 2,
                        aTargets: [ -1 ]
                    },
                {
                    render: function (data, type, row) { 
                        let statusCls = "";
                        if(data==='Settled'){
                            statusCls = "txnsuccess";
                        }
                        if(data==='Failed'){
                            statusCls = "txnfailed";
                        }
                        if(data==='Unsettled'){
                            statusCls = "txnvoid";
                        }
                        if(data==='reversal'){
                            statusCls = "txnreversal";
                        }
                        return '<td> <div class="'+statusCls+'">'+data+'</div></td>';
                    },
                    className: "",
                    targets: 5,
                    aTargets: [-1]
                },
                {
                    render: function (data, type, row) {
                        return '<td >&#8377;'+data+' </td>';
                    },
                    
                    targets: 3,
                   
                },
                {
                    render: function (data, type, full, meta) {
                        if(data===null || data===''|| data ==='null'){
                        data = '';
                        }
                        return "<div class='text-wrap width-80'>" + data + "</div>";
                    },
                    "targets": [2,5]
                },
                {
                    render: function (data, type, row, full, meta) {
                        if(data===null || data===''|| data ==='null'){
                        data = '';
                        }
                        return "<div class='text-wrap width-80'>" + data + ' '+row["Transaction Time"]+ "</div>";
                    },
                    "targets": [4]
                    }

               
            ],

        });

        $('#TrListsTable').on('click', 'td.charge_slip a', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            var code = $(this).data("code");
            var acqbank = $(this).data("acqbank");
            var trdate = $(this).data("trdate");
            var prim_id = $(this).data("primid");

            let win=window.open('about:blank','popUpWindow', 'height=500,width=400,left=100,top=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes' )
            var perLoad = '<div style="text-align: center" id="loaderDiv"><img src=" '+ loadingGif +' "></div>';
            win.document.write(perLoad)

            $.ajax({
                url:config.get('API_URL')+ "/reports/generate_slip/?code="+code+"&acq_bank_name="+acqbank+"&transaction_date="+trdate+"&prim_id="+prim_id,
                type: 'GET',

                beforeSend: function (request) {
                    request.setRequestHeader("Authorization", localStorage.usertoken);
                },
                success: function (response) {
                    that.setState({
                        opened: true,
                        chargeSlipPopup: true,
                        slipData:response
                    })
                    win.document.close();
                    win.document.write(that.state.slipData);



                },
                //dataType: 'html'
            })
        })
    }
    changeUtid(e){
        this.setState({
            utid:e.target.value
        })
    }
    checkUtid(e){
        this.setState({
            search_loading: true
        })
        axios.post(config.get('API_URL')+'/ftcr/check-utid/',{
            utid: this.state.utid,
        },
        {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },

        }).then(response => {
            console.log(response)
            this.setState({
            search_loading: false
        })
            if(response.data==='data does not exist') {
                this.props.handleClick("tr", 3, "Please enter valid UTID");
            } else {
                this.setState({
                    is_valid_utid:true
                })
                if(this.state.show_details==='transaction today'){
                    setTimeout(function(){
                        this._get_tr_listing();
                        this._get_m_s_details();
                        this._get_terminal_details();
                    }.bind(this), 200);
                }
                if(this.state.show_details==='last settlement'){
                    setTimeout(function(){
                        this._get_settlement_listing();
                        this._get_m_s_details();
                        this._get_terminal_details();
                    }.bind(this), 200);
                }
                if(this.state.show_details==='feature mapping'){
                    setTimeout(function(){
                        this._get_feature_mapping();
                        this._get_m_s_details();
                        this._get_terminal_details();
                    }.bind(this), 200);
                }
                this.get_transaction_count();
                this.get_last_settlement();
            }
        });
    }
    handleEvent(event, picker, e) {
        this.setState({
            todSend: moment(picker.endDate).format('YYYY-MM-DD'),
            yestSend: moment(picker.startDate).format('YYYY-MM-DD'),
            datefromShow: moment(picker.startDate).format('D MMM YYYY'),
            dateToShow: moment(picker.endDate).format('D MMM YYYY')
        });
        if(event.type=='apply'){
          this.setState({
                isChange: true
            })

        }
    }

    handleEventWdetails(event, picker, e) {
        this.setState({
            todSendw: moment(picker.endDate).format('YYYY-MM-DD'),
            yestSendw: moment(picker.startDate).format('YYYY-MM-DD'),
            datefromShoww: moment(picker.startDate).format('D MMM YYYY'),
            dateToShoww: moment(picker.endDate).format('D MMM YYYY')
        });
        if(event.type=='apply'){
            this._get_wallet_details();
        }
    }

    handleEventSettl(event, picker, e) {
        this.setState({
            todSends: moment(picker.endDate).format('YYYY-MM-DD'),
            yestSends: moment(picker.startDate).format('YYYY-MM-DD'),
            datefromShows: moment(picker.startDate).format('D MMM YYYY'),
            dateToShows: moment(picker.endDate).format('D MMM YYYY')
        });
        if(event.type=='apply'){
            this._get_settlement_listing();
        }
    }
    openCloseBar(){
       var col = "col-md-9"
       if(this.state.ftcr_sidebar===true){
        col = "col-md-12"
       }
       this.setState({
            ftcr_sidebar: !this.state.ftcr_sidebar,
            rightBar:col
       })

    }
    changeView(view,e){
        if(view==='transaction today'){
            setTimeout(function(){
                this._get_tr_listing();
                //this._get_m_s_details();
            }.bind(this), 200);
        }
        if(view==='last settlement'){
            setTimeout(function(){
                this._get_settlement_listing();
                //this._get_m_s_details();
            }.bind(this), 200);
        }
        if(view==='feature mapping'){
            setTimeout(function(){
                this._get_feature_mapping();
                //this._get_m_s_details();
            }.bind(this), 200);
        }
        this.setState({
            show_details: view
        })

    }

    _get_feature_mapping(){
        this.setState({
            feature_loading: true
        });
        if ($.fn.DataTable.isDataTable('#FeaMapTable')) {
            $('#FeaMapTable').DataTable().destroy();
        }

         axios.post(config.get('API_URL')+'/ftcr/get_feature_mapping/',{
                utid: this.state.utid,
            },
            {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }

        }).then(response => {
             var tdata =  [];
             if (Array.isArray(response.data.data) && response.data.data.length) {
                 tdata = response.data;

                 this.setState({
                     feature_data: tdata,
                     feature_loading:false
                 });
             } else {

             tdata = response.data;
                 this.setState({
                     feature_data: tdata,
                     feature_loading:false
                 })
             }
             $('#FeaMapTable').DataTable({
                bInfo : false,
                paging: false,
             });

        }).catch( err => {
            console.log(err);
        });
    }
    _get_m_s_details(){
        axios.post(config.get('API_URL')+'/ftcr/get-merchant-and-store/',{
                utid: this.state.utid,
            },
            {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }

        }).then(response => {
            this.setState({
                merchant_name: response.data.merchant_name,
                chain_name:response.data.chain_name,
                store_name:response.data.store_name,
                store_code: response.data.store_code,
                store_address: response.data.store_adddress1,
                city_name: response.data.city_name
            })
        }).catch( err => {
            console.log(err);
        });
    }
    _get_terminal_details(){
         axios.post(config.get('API_URL')+'/ftcr/get-terminal-details/',{
                utid: this.state.utid,
               },
            {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
         }).then(response => {
//             console.log(response.data.data)

            this.setState({
                terminal_model: response.data.data[0].terminal_model,
                product_type:response.data.data[0].product_type,
                software_version:response.data.data[0].software_version,
                utid: response.data.data[0].utid,
                serial_number: response.data.data[0].serial_number

            })
        }).catch( err => {
            console.log(err);
        });
    }


    _get_wallet_details(){
        this.setState({
            wallet_loading:true
        })
        if ($.fn.DataTable.isDataTable('#walletTable')) {
            $('#walletTable').DataTable().destroy();
        }
        var wdata =  [];
        axios.post(config.get('API_URL')+'/ftcr/get-wallet-top-up-details/',{
                utid: this.state.utid,
                start_date: this.state.yestSendw,
                end_date: this.state.todSendw,
            },
            {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }

        }).then(response => {
            var wdata =  response.data.data;
            this.setState({
                 wallet_data: wdata,
                 wallet_loading:false
             });
              $('#walletTable').DataTable(
             );
        }).catch( err => {
            console.log(err);
        });
    }

    _get_btid_details(){
        this.setState({
            btid_loading:true
        })
        if ($.fn.DataTable.isDataTable('#BTIDTable')) {
            $('#BTIDTable').DataTable().destroy();
        }
        var wdata =  [];
        axios.post(config.get('API_URL')+'/ftcr/get-btid-details/',{
                utid: this.state.utid,
            },
            {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }

        }).then(response => {
            var wdata =  response.data;
            this.setState({
                 btid_data: wdata,
                 btid_loading:false
             });
              $('#BTIDTable').DataTable(
             );
        }).catch( err => {
            console.log(err);
        });
    }


    toggleNewModel(modal_type,e) {

        this.setState({
            newModel: !this.state.newModel,
            action_type: modal_type
        })
        if(modal_type==='BTID Details'){
            this._get_btid_details();
        } else if(modal_type==='Wallet Top Up Details') {
            this._get_wallet_details();
        } else if(modal_type==='Settlement Details') {

        }

    }
    _get_settlement_listing(){
        var that = this;
        var postData = {
            utid: this.state.utid,
            yestSend: this.state.yestSends,
            todSend: this.state.todSends,
        };
        if ($.fn.DataTable.isDataTable('#SettelListsTable')) {
            $('#SettelListsTable').DataTable().clear().destroy();
        }
        var SettelListsReportTable = $('#SettelListsTable').DataTable({
            order:[],
            "processing": true,
            "serverSide": true,
            "bDestroy": true,
            "paging": true,
            "pageLength": 10,
            "bInfo" : false,
            "autoWidth": false,
            "responsive": true,
            "searching": true,
            "lengthMenu": [[10, 50, 100, 500 -1], [10, 50, 100, 500, "All"]],
            ajax: {
                url:config.get('API_URL')+ "/ftcr/get-ftcr-settlement-listing",
                type: "POST",
                data: postData,
                dataSrc:function ( json ) { console.log(json);
                    enabledBody()
                    that.setState({
                        isChange: false
                    })
                    return json.data;
                },
                beforeSend: function(request) {
                    request.setRequestHeader("Authorization", localStorage.usertoken);
                },
                error: function (data) {
                    enabledBody()
                },
                complete: function (data) {
                    enabledBody()
                },
            },

            columns: [
                {"data":"UTR Number" },
                {"data":"Settlement Date"},
                {"data":"Transferred amount"},
                {"data":"Settled amount"},
                {"data":"Settlement status"},
            ],
            "columnDefs": [
                {
                    render: function (data) {
                      if(data===null || data===''|| data ==='null'){
                            data = '';
                      }
                        return '<td ><div class="collapseFirstTD"><a href="#">'+data+'</a> </div></td>';
                    },
                    className: "clickable",
                    targets: 0,
                    aTargets: [ -1 ]
                },

                {
                    render: function (data, type, row) {
                        let statusCls = "";
                        if(data==='Settled'){
                            statusCls = "txnsuccess";
                        }
                        if(data==='Failed'){
                            statusCls = "txnfailed";
                        }
                        if(data==='Unsettled'){
                            statusCls = "txnvoid";
                        }
                        if(data==='reversal'){
                            statusCls = "txnreversal";
                        }

                        return '<td> <div class="'+statusCls+' text-wrap width-80">'+data+'</div></td>';

                    },

                    className: "",
                    targets: 4,
                    aTargets: [-1]
                },


            ],

        });
        $('#SettelListsTable').on('click', 'td.clickable', function(e){
//         alert("hi");
            e.preventDefault();

            var tr = $(this).closest('tr');
            var row = SettelListsReportTable.row( tr );
            if(row.data()!=undefined) {
            that.toggleNewModel('Settlement Details', '');
            console.log(row.data());
//             alert(row.data()["UTR Number"]);
            var postData = {
                utid: that.state.utid,
                yestSend: that.state.yestSends,
                todSend: that.state.todSends,
                settlement_utr: row.data()["UTR Number"]
            };
            setTimeout(function(){

                that.setState({
                    sd_loading:true
                })
                if ($.fn.DataTable.isDataTable('#SettelDetailTable')) {
                    $('#SettelDetailTable').DataTable().destroy();
                }
                var sdata =  [];
                axios.post(config.get('API_URL')+'/ftcr/get-ftcr-settlement-details/', postData, {
                    headers: {
                        Authorization: ` ${localStorage.usertoken}`
                    }

                }).then(response => {
                    var sdata =  response.data.data;
                    that.setState({
                         sdetails_data: sdata,
                         sd_loading:false
                     });
                      $('#SettelDetailTable').DataTable({
                          "responsive": true,
                          "scrollX": false,
                      }

                     );
                }).catch( err => {
                    console.log(err);
                });

             }, 200);

            }
        });
    }
    changeIsSettled(optionSelected){
        const value = optionSelected === null ? '' : optionSelected.value;

        this.setState({
            isSettledIDs:value,
            isSettledValue:optionSelected,
            isChange: true
        });

    }

    get_transaction_count(){
        axios.post(config.get('API_URL')+'/ftcr/get-tr-count/',{
                utid: this.state.utid,
            },
            {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }

        }).then(response => {
            this.setState({
                transaction_count: response.data.data[0].txn_count,

            })
        }).catch( err => {
            console.log(err);
        });
    }
    get_last_settlement(){
        axios.post(config.get('API_URL')+'/ftcr/get-last-settlement/',{
                utid: this.state.utid,
            },
            {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }

        }).then(response => {
            this.setState({
                last_settlement_date: response.data.data[0].last_settlement_date,
                last_transaction_amount: response.data.data[0].last_transaction_amount,
            })
        }).catch( err => {
            console.log(err);
        });
    }

    render() {

        let featureTableData = this.state.feature_data.map((val,index) => {
            return (
                <tr key={index + 1}>
                    <td>{val["feature_name"]}</td>
                    <td>
                    <div style={{display:"none"}}>{val["status"]}</div>
                    {val["status"]==='ENABLE'?

                    <i class="fa fa-check-circle" style={{color:"green", fontSize:"30px"}}></i>:
                    <i class="fa fa-times-circle" style={{color:"red", fontSize:"30px"}}></i>}
                    </td>
                </tr>
            )
        });

        let walletTableData = this.state.wallet_data.map((val,index) => {
            let topUpTime = val["Top-up Date and time"];
            if(val["Top-up Date and time"]!==null || val["Top-up Date and time"]!=='null' || val["Top-up Date and time"]!=='') {
               topUpTime = moment(val["Top-up Date and time"]).format('D MMM YYYY HH:mm:ss')
            }
            return (
                <tr key={index + 1}>
                    <td>{topUpTime}</td>
                    <td>{val["Transaction reference number"]}</td>
                    <td>{val["Top-up plan"]}</td>
                    <td>{val["Wallet amount added"]}</td>
                    <td>{val["Final wallet balance"]}</td>
                </tr>
            )
        });

        let btidTableData = this.state.btid_data.map((val,index) => {

            return (
                <tr key={index + 1}>
                    <td>{val.acq_bank_name}</td>
                    <td>{val.btid}</td>
                    <td>{val.bank_merchant_id}</td>
                    <td>{val.saletype}</td>
{/*                     <td>{val["Final wallet balance"]}</td> */}
                </tr>
            )
        });

        let sDetailsTableData = this.state.sdetails_data.map((val,index) => {

            return (
                <tr key={index + 1}>

                     <td width="200px" ><div className="text-wrap width-80">{val.transaction_date}</div></td>
                     <td>{val.prim_id}</td>
                     <td>{val["Transaction Amount"]}</td>
                     <td>{val["Instant Discount"]}</td>
                     <td>{val["MDR Amount"]}</td>
                     <td>{val["GST on transaction fee"]}</td>
                     <td>{val["EMI Processing Fee"]}</td>
                     <td>{val["GST on EMI Processing fee"]}</td>
                     <td>{val["Rental charge with GST"]}</td>
                     <td>{val["Total Deduction"]}</td>
                     <td>{val["Final Txfr Amount"]}</td>
                     <td>{val["Settlement status"]}</td>
                     <td>{val["Settlement UTR"]}</td>
                     <td>{val["Settlement Date"]}</td>
                </tr>
            )
        });

        const MenuList = props => {
            const rows = props.children;
            let no_of_rows = 0;
            let drop_down_heigth = 0
            if (rows.length !== undefined) {
                no_of_rows = rows.length;
                if (no_of_rows < 9) { drop_down_heigth = 40 * no_of_rows; }
                else {
                    drop_down_heigth = 300;
                }

            }
            const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
                <div key={key} style={style}>{rows[index]}</div>
            );

            return (
                <List
                    style={{ width: '100%' }}
                    width={300}
                    height={drop_down_heigth}
                    rowHeight={30}
                    rowCount={no_of_rows}
                    rowRenderer={rowRenderer}
                />
            )
        }
        const customStyles = {
            control: provided => ({
                ...provided,
                padding: "0px",
                minHeight: "30px",
            }),
            indicatorsContainer: provided => ({
                ...provided,
                height: "35px"
            }),
            clearIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            dropdownIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            valueContainer: base => ({
                ...base,
                padding: '0px 6px'
            }),
            menu: styles => ({ ...styles, zIndex: 999 })
        };

        return (

            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 m-t-10">
                            {this.state.is_valid_utid===false?
                            <React.Fragment>
                                <div class="row justify-content-md-center top-100">
                                    <div class="col-md-4"></div>
                                    <div class="col-md-4">
                                        <input type="text" name="utid" class="form-control" placeholder="Enter UTID" value={this.state.utid} onChange={this.changeUtid.bind(this)}/> 
                                        <div className="btn-utid-search">
                                            <button type="button" className="btn btn-primary" onClick={this.checkUtid.bind(this)}>Search</button>   
                                        </div>
                                        <BeatLoader
                                            css={override}
                                            sizeUnit={"px"}
                                            size={10}
                                            color={'#123abc'}
                                            loading={this.state.search_loading}
                                        />
                                        
                                    </div>
                                    <div class="col-md-4"></div>
                                </div>
                            </React.Fragment>:
                            <div className="">
                                <div className="row">
                                {this.state.ftcr_sidebar===true?
                                    <div class="col-md-3 padd-5 ss">
                                        <div class="card">

                                            <div class="ftcr-le-titile">Merchant & Store Details</div>
                                            <table width="100%" border="0" className="ftcr-de-table">
                                                <tr>
                                                    <td width="40%">Merchant Name</td>
                                                    <td width="2px">:</td>
                                                    <td width="59%">{this.state.merchant_name}</td>
                                                </tr>
                                                <tr>
                                                    <td width="40%">Chain Name</td>
                                                    <td width="2px">:</td>
                                                    <td width="59%">{this.state.chain_name}</td>
                                                </tr>
                                                <tr>
                                                    <td width="40%">Store Name</td>
                                                    <td width="2px">:</td>
                                                    <td width="59%">{this.state.store_name}</td>
                                                </tr>
                                                <tr>
                                                    <td width="40%">Store Code</td>
                                                    <td width="2px">:</td>
                                                    <td width="59%">{this.state.store_code}</td>
                                                </tr>
                                                <tr>
                                                    <td width="40%">Store Address</td>
                                                    <td width="2px">:</td>
                                                    <td width="59%">{this.state.store_address===''?null:this.state.store_address.replace(/,/g, ', ')}</td>
                                                </tr>
                                                <tr>
                                                    <td width="40%">Store City</td>
                                                    <td width="2px">:</td>
                                                    <td width="59%">{this.state.city_name}</td>
                                                </tr>
                                                <tr width="40%">
{/*                                                     <td>Bussiness Phone No.</td> */}
{/*                                                     <td width="2px">:</td> */}
{/*                                                     <td></td> */}
                                                </tr>
{/*                                                 <tr width="40%"> */}
{/*                                                     <td width="40%"><a href="#">Dealer Code</a></td> */}
{/*                                                     <td width="2px"></td> */}
{/*                                                     <td width="59%"></td> */}
{/*                                                 </tr> */}
                                            </table>
                                            <br></br>
                                            <div class="ftcr-le-titile">Terminal Details</div>
                                            <table width="100%" border="0" className="ftcr-de-table">
{/*                                                 <tr> */}
{/*                                                     <td width="40%">Terminal Model</td> */}
{/*                                                     <td width="2px">:</td> */}
{/*                                                     <td width="59%">{this.state.terminal_model}</td> */}

{/*                                                 </tr> */}
                                                <tr>
                                                    <td width="40%">Product Type</td>
                                                    <td width="2px">:</td>
                                                    <td width="59%">{this.state.product_type}</td>

                                                </tr>
                                                <tr>
                                                    <td width="40%">Last updated software version</td>
                                                    <td width="2px">:</td>
                                                    <td width="59%">{this.state.software_version}</td>

                                                </tr>
                                                <tr>
                                                    <td width="40%">UTID</td>
                                                    <td width="2px">:</td>
                                                    <td width="59%">{this.state.utid}</td>

                                                </tr>
                                                <tr>
                                                    <td width="40%">Terminal Serial No.</td>
                                                    <td width="2px">:</td>
                                                    <td width="59%">{this.state.serial_number}</td>

                                                </tr>
                                                <tr>
                                                    <td width="40%">Wallet Balance</td>
                                                    <td width="2px">:</td>

                                                </tr>
                                                <tr width="40%">
                                                    <td><a href="#" onClick={this.toggleNewModel.bind(this,'BTID Details')}>BTID Details</a></td>
                                                    <td width="2px"></td>
                                                    <td><a href="#" onClick={this.toggleNewModel.bind(this,'Wallet Top Up Details')}>Wallet Top Up Details</a></td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div> :null}
                                    <div className={this.state.rightBar}>

                                        <div className="row mar-botton-10">
                                        <div style={{marginBottom:"5px"}}>
                                        <button type="button" className="btn btn-primary toggleIconBtn" onClick={this.openCloseBar.bind(this)}>
                                        {this.state.ftcr_sidebar===true?<i class="fa fa-close"></i>:<i class="fa fa-bars"></i>}
                                        </button>&nbsp;&nbsp;&nbsp;
                                            <input type="text" name="utid" class="form-control change-utid-box" placeholder="Enter UTID" value={this.state.utid} onChange={this.changeUtid.bind(this)}/> 
                                            &nbsp;&nbsp;<button type="button" className="btn btn-primary changeBtn" onClick={this.checkUtid.bind(this)}>Change</button>
{/*                                             <BeatLoader */}
{/*                                             css={override} */}
{/*                                             sizeUnit={"px"} */}
{/*                                             size={10} */}
{/*                                             color={'#123abc'} */}
{/*                                             loading={this.state.search_loading} */}
{/*                                         /> */}
                                        </div>
                                            {/* ---------------KPIS------------------ */}
                                            <div class="col-md-3 padd-5-right">
                                                <div class="ftcr-card col-md-12 p-0">
                                                    <div class="col-md-12">
                                                        <p class="m-t-10"><strong>{this.state.transaction_count}</strong></p>
                                                        <p class="m-t-10">Transactions Today</p>
                                                    </div>
                                                </div>
                                                <div class="clearfix"></div>
                                                {this.state.show_details==='transaction today'?
                                                <div class="view-details-link-active"><a href="#" onClick={this.changeView.bind(this,'transaction today')}>View Details»</a></div>:
                                                <div class="view-details-link"><a href="#" onClick={this.changeView.bind(this,'transaction today')}>View Details»</a></div>}
                                            </div>

                                            <div class="col-md-3 padd-5-right">
                                                <div class="ftcr-card col-md-12 p-0">
                                                    <div class="col-md-12">
                                                        <p class="m-t-10">&#8377; {this.state.last_transaction_amount} </p>
                                                        <p class="m-t-10">Last Settlement at </p>
                                                        <p class="m-t-10">{this.state.last_settlement_date===''?null:moment(this.state.last_settlement_date).format('D MMM YYYY')}</p>
                                                    </div>
                                                </div>
                                                <div class="clearfix"></div>
                                                {this.state.show_details==='last settlement'?
                                                <div class="view-details-link-active"><a href="#" onClick={this.changeView.bind(this,'last settlement')}>View Details»</a></div>:
                                                <div class="view-details-link"><a href="#" onClick={this.changeView.bind(this,'last settlement')}>View Details»</a></div>}
                                            </div>
{/*                                             <div class="col-md-3 padd-5-right"> */}
{/*                                                 <div class="ftcr-card col-md-12 p-0"> */}
{/*                                                     <div class="col-md-12"> */}
{/*                                                         <p class="m-t-10">Scheme Search</p> */}
{/*                                                     </div> */}
{/*                                                 </div> */}
{/*                                                 <div class="clearfix"></div> */}
{/*                                                 {this.state.show_details==='scheme search'? */}
{/*                                                 <div class="view-details-link-active"><a href="#" onClick={this.changeView.bind(this,'scheme search')}>View Details»</a></div>: */}
{/*                                                 <div class="view-details-link"><a href="#" onClick={this.changeView.bind(this,'scheme search')}>View Details»</a></div>} */}
{/*                                             </div> */}
                                            <div class="col-md-3 padd-5-right">
                                                <div class="ftcr-card col-md-12 p-0">
                                                    <div class="col-md-12">
                                                        <p class="m-t-10">Feature Mapping</p>
                                                    </div>
                                                </div>
                                                <div class="clearfix"></div>
                                                {this.state.show_details==='feature mapping'?
                                                <div class="view-details-link-active"><a href="#" onClick={this.changeView.bind(this,'feature mapping')}>View Details»</a></div>:
                                                <div class="view-details-link"><a href="#" onClick={this.changeView.bind(this,'feature mapping')}>View Details»</a></div>}
                                            </div>                                        
                                        </div>
                                        <div className="content card">
                                        {this.state.show_details==='transaction today'?
                                            <div>
                                                <div className="col-md-4">
                                                    <div class="header font-20" style={{paddingBottom:"0px"}}>
                                                        <h4 class="title">Transactions Listing</h4>
                                                    </div>

                                                </div>
                                                <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                                <div><label> Date Filter: </label></div>
                                                    <DateRangePicker startDate={this.state.datefrom} endDate={this.state.dateTo}
                                                                    onEvent={this.handleEvent.bind(this)} maxDate = {this.state.dateLimit}
                                                                    minDate = {this.state.dateFromLimit}>
                                                        <i className="fa fa-calendar" aria-hidden="true"></i>
                                                        <input type="text" name="dateRange"
                                                            className="form-control dateRangeInput"
                                                            value={this.state.datefromShow + ' - ' + this.state.dateToShow}/>
                                                    </DateRangePicker>
                                                </div>
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label> Txn Status </label>
                                                    <Select name="status"

                                                            value={this.state.isSettledValue}
                                                            styles={customStyles} className="report-listbox"
                                                            isClearable={false}
                                                            onChange={this.changeIsSettled.bind(this)}
                                                            options={this.state.isSettledLists}

                                                    />
                                                    <div className="clearfix"></div>
                                                </div>
                                                <div className="col-md-3">
                                                {this.state.isChange===true?
                                                <span className="apply-notification">Please click on Apply button</span>:null
                                                }
                                                <button type="button" className="primary apply-filter" role="button" onClick={this._get_tr_listing.bind(this)}>Apply</button>
{/*                                                 <button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button> */}
                                                </div>

                                                <div className="clearfix"></div>

                                                <div className="content-tdetails-table table-full-width table-responsive marginTop0">

                                                        <table id="TrListsTable" className="table table-striped table-hover">
                                                            <thead>
                                                                <tr>
                                                                    <th>Prim ID</th>
                                                                    <th>Transaction type</th>
                                                                     <th>View Charge slip</th>
                                                                    <th>Txn Amount</th>
                                                                    <th>Txn Date Time</th>
{/*                                                                     <th>Txn Time</th> */}
                                                                    <th>Txn Status</th>

                                                                    <th>Card Holder Name</th>
                                                                   <th>Issuer Bank</th>
                                                                   <th>Card Number</th>
                                                                   <th>Acquiring Bank</th>
                                                                   <th>Settlement status</th>
                                                                   <th>Tenure</th>
                                                                   <th>ROI</th>
                                                                   <th>Error Reason</th>
                                                                   <th>Category</th>
                                                                   <th>Brand</th>
                                                                   <th>Model</th>
                                                                   <th>Btid</th>
                                                                   <th>co_reason_message</th>
                                                                   <th>RRN No</th>
                                                                   <th>parent_prim_id</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody> </tbody>
                                                        </table>

                                                </div>

                                            </div>:null}

                                            {this.state.show_details==='last settlement'?
                                            <div>
                                                <div className="col-md-6">
                                                    <div class="header font-20" style={{paddingBottom:"0px"}}>
                                                        <h4 class="title">Settlement Listing</h4>
                                                    </div>
                                                </div>
                                                <div className="col-md-3 ftcrTR pull-right">
                                                    <DateRangePicker startDate={this.state.datefroms} endDate={this.state.dateTos}
                                                                    onEvent={this.handleEventSettl.bind(this)} maxDate = {this.state.dateLimits}
                                                                    minDate = {this.state.dateFromLimits}>
                                                        <i className="fa fa-calendar" aria-hidden="true"></i>
                                                        <input type="text" name="dateRange"
                                                            className="form-control dateRangeInput"
                                                            value={this.state.datefromShows + ' - ' + this.state.dateToShows}/>
                                                    </DateRangePicker>
                                                </div>
                                                <div className="clearfix"></div>

                                                <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                                    <div>
                                                        <table id="SettelListsTable" className="table table-striped table-hover">
                                                            <thead>
                                                                <tr>
                                                                    <th>Settlement UTR</th>
                                                                    <th>Settlement Date</th>
                                                                    <th>Transferred amount</th>
                                                                    <th>Settled amount</th>
                                                                    <th>Settlement status</th>

                                                                </tr>
                                                            </thead>
                                                            <tbody> </tbody>
                                                        </table>
                                                    </div>
                                                </div>

                                            </div>:null}
                                            {this.state.show_details==='feature mapping'?
                                            <div>
                                                <div className="col-md-6">
{/*                                                     <div class="header font-20" style={{paddingBottom:"0px"}}> */}
{/*                                                         <h4 class="title">Transactions Listing</h4> */}
{/*                                                     </div> */}
                                                </div>

                                                <div className="clearfix"></div>

                                                <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                                    <div>
                                                        <table id="FeaMapTable" className="table table-striped table-hover">
                                                            <thead>
                                                                <tr>
                                                                    <th>Feature Name</th>
                                                                    <th>Status</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>

                                                            {featureTableData}
                                                            </tbody>
                                                        </table>
                                                        <BeatLoader
                                                            css={override}
                                                            sizeUnit={"px"}
                                                            size={10}
                                                            color={'#123abc'}
                                                            loading={this.state.feature_loading}
                                                        />
                                                    </div>
                                                </div>

                                            </div>:null}
                                        </div>
                                    </div>
                                    <Modal isOpen={this.state.newModel} toggle={this.toggleNewModel.bind(this, this.state.action_type)}>
                                    <ModalHeader toggle={this.toggleNewModel.bind(this, this.state.action_type)}>{this.state.action_type}</ModalHeader>
                                    <ModalBody className="user_form_fields">
                                    <div className="row">
                                        <div className="col-md-12">
                                        {this.state.action_type==='Wallet Top Up Details'?
                                        <div className="col-md-3 ftcrTR pull-right">
                                            <DateRangePicker startDate={this.state.datefromw} endDate={this.state.dateTow}
                                                            onEvent={this.handleEventWdetails.bind(this)} maxDate = {this.state.dateLimitw}
                                                            minDate = {this.state.dateFromLimitw}>
                                                <i className="fa fa-calendar" aria-hidden="true"></i>
                                                <input type="text" name="dateRange"
                                                    className="form-control dateRangeInput"
                                                    value={this.state.datefromShoww + ' - ' + this.state.dateToShoww}/>
                                            </DateRangePicker>
                                        </div>: null}
                                        <div className="clearfix"></div>
                                        {this.state.action_type==='Wallet Top Up Details'?
                                        <table id="walletTable" className="table table-striped table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Top-up Date and time</th>
                                                    <th>Transaction reference number</th>
                                                    <th>Top-up plan</th>
                                                    <th>Wallet amount added</th>
                                                    <th>Final wallet balance</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                            {walletTableData}
                                            </tbody>
                                        </table>:null}
                                        <BeatLoader
                                            css={override}
                                            sizeUnit={"px"}
                                            size={10}
                                            color={'#123abc'}
                                            loading={this.state.wallet_loading}
                                        />
                                        {this.state.action_type==='BTID Details'?
                                        <table id="BTIDTable" className="table table-striped table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Acquirer Bank Name</th>
                                                    <th>BTID</th>
                                                    <th>Bank Merchant ID</th>
                                                    <th>Sale Type</th>
{/*                                                     <th>Final wallet balance</th> */}
                                                </tr>
                                            </thead>
                                            <tbody>

                                            {btidTableData}
                                            </tbody>
                                        </table>:null}
                                        <BeatLoader
                                            css={override}
                                            sizeUnit={"px"}
                                            size={10}
                                            color={'#123abc'}
                                            loading={this.state.btid_loading}
                                        />

                                        {this.state.action_type==='Settlement Details'?
                                        <table id="SettelDetailTable" className="table table-striped table-hover">
                                            <thead>
                                                <tr>
                                                     <th width="200px">Transaction Date</th>
                                                     <th>Prim ID</th>
                                                     <th>Transaction Amount</th>
                                                     <th>Instant Discount</th>
                                                     <th>MDR Amount</th>
                                                     <th>GST on transaction fee</th>
                                                     <th>EMI Processing Fee</th>
                                                     <th>GST on EMI Processing fee</th>
                                                     <th>Rental charge with GST</th>
                                                     <th>Total Deduction</th>
                                                     <th>Final Txfr Amount</th>
                                                     <th>Settlement status</th>
                                                     <th>Settlement UTR</th>
                                                     <th>Settlement Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {sDetailsTableData}
                                            </tbody>
                                        </table>:null}
                                        <BeatLoader
                                            css={override}
                                            sizeUnit={"px"}
                                            size={10}
                                            color={'#123abc'}
                                            loading={this.state.sd_loading}
                                        />
                                        </div>
                                    </div>
                                    </ModalBody>
                                    <ModalFooter>
                                    </ModalFooter>
                            </Modal>
                                    <div className="clearfix"></div>
                                </div>
                            </div>}
                            <div className="footer">
                                <div className="stats"><i></i> </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        currentMenu: (name) => { dispatch({ type: 'change_menu', payload: name }) }
    }
}
export default connect(null, mapDispatchToProps)(FundDashboard);